import { orderIsFreeShippingEligible } from "../../utils/orderIsFreeShippingEligible";
import { ViewOrderInvoiceCTA } from "./ctas";
export var DidNotGetInsiderFreeShippingIA = function DidNotGetInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  return ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return undefined;
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
var ORDER_IS_FREE_SHIPPING_INELIGIBLE = function ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var ORDER_IS_FREE_SHIPPING_ELIGIBLE = function ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING = function WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "AFUJpc",
    defaultMessage: [{
      "type": 0,
      "value": "Pourquoi n'ai-je pas bénéficié de la livraison gratuite avec Insider sur ma commande ?"
    }]
  });
};
var INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "n75Vyn",
    defaultMessage: [{
      "type": 0,
      "value": "Il est important de savoir que votre abonnement Insider offre la livraison gratuite pour certaines marques. Bien que cet avantage ne s'applique pas à l'ensemble de la plateforme, vous pouvez facilement identifier les marques proposant cette option sur Faire. Il vous suffit de rechercher les marques portant la mention « Livraison gratuite avec Insider » ainsi qu'une clé bleue. De plus, il vous sera indiqué lors du passage en caisse si votre abonnement Insider prend en charge les frais d'expédition pour une marque spécifique. Si ce n'est pas le cas, vous verrez la mention « À déterminer » ou une estimation des frais d'expédition."
    }]
  });
};
var ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING = function ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HkpAbF",
    defaultMessage: [{
      "type": 0,
      "value": "La commande que vous avez sélectionnée devrait bénéficier de la livraison gratuite avec Insider. Pour confirmer si la livraison gratuite avec Insider a été appliquée à cette commande, accédez à l'onglet « Factures » sur votre portail Faire et recherchez la facture correspondante. Vérifiez la ligne des frais de livraison : elle doit indiquer clairement que la livraison gratuite avec Insider est appliquée à cette commande. Si ce n'est pas le cas, contactez notre équipe d'assistance pour obtenir de l'aide."
    }]
  });
};